import { render, staticRenderFns } from "./searchModal.vue?vue&type=template&id=2fe5e666&lang=pug&"
import script from "./searchModal.vue?vue&type=script&lang=js&"
export * from "./searchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports